<template>
    <b-media vertical-align="center">
        <b-row>
            <b-col sm="12" md="12" lg="6" xl="8">
                <b-row no-gutters>
                    <b-col>
                        <indicator-progress :target="target" />
                    </b-col>
                </b-row>
            </b-col>
            <b-col sm="6" lg="3" xl="2" align-self="center">
                <div class="mt-3 mt-xl-0">
                    <checkin-button
                        :target="target"
                        :isAllowedToDoCheckin="canDoCheckIn"
                        @checkin="openTheModalCheckIn()"
                    />
                </div>
            </b-col>
            <b-col sm="6" lg="3" xl="2" align-self="center">
                <div class="text-center mt-3 mt-xl-0">
                    <edit-button
                        :targetId="target.id"
                        :targetLevel="target.level"
                        :isAllowedToEdit="isAllowedToEdit"
                        @edit="editTarget"
                        @delete="deleteTarget"
                    />
                </div>
            </b-col>
        </b-row>
    </b-media>
</template>

<script>
import { CheckinButton, EditButton, IndicatorProgress } from '@/views/target/components/view/indicator-header'
import Swal from 'sweetalert2'
import i18n from '@/i18n'
import { deleteConfirmationWithLoading } from '@/config/sweet-alert'
import notification, { success, danger } from '@/lib/notification'
import api from '@/services/api'

notification.init()

export default {
    name: 'KpiHeader',
    props: ['target', 'currentUserId', 'currentEventPermissions', 'isAllowedToEdit'],
    components: {
        CheckinButton,
        EditButton,
        IndicatorProgress,
    },
    computed: {
        canDoCheckIn() {
            const targetIsNotCompleted = !(this.target.status === 'completed')
            const checkInPermission = this.currentEventPermissions[this.target.level].checkin
            return targetIsNotCompleted && checkInPermission
        },
    },
    methods: {
        openTheModalCheckIn() {
            return this.$router.push({
                path: `/v2/target/indicators/view/${this.target.id}/checkin`,
            })
        },
        deleteTargetFromAPI(id) {
            return api.delete(`/kpi/${id}`).catch((e) => {
                throw new e()
            })
        },
        editTarget({ targetId, targetLevel }) {
            const editPermission = this.currentEventPermissions[targetLevel].edit
            if (!editPermission) {
                Swal({
                    type: 'warning',
                    title: i18n.t('notification.permissions.editDenied', {
                        item: i18n.t('targets.target'),
                    }),
                })
            } else {
                this.$router.push(`/v2/target/indicators/edit/${targetId}`)
            }
        },
        deleteTarget({ targetId, targetLevel }) {
            const deletePermission = this.currentEventPermissions[targetLevel].delete
            if (!deletePermission) {
                Swal({
                    type: 'warning',
                    title: i18n.t('notification.permissions.deleteDenied', {
                        item: i18n.t('targets.target'),
                    }),
                })
            } else {
                Swal({
                    ...deleteConfirmationWithLoading,
                    preConfirm: () => {
                        return this.deleteTargetFromAPI(targetId)
                    },
                })
                    .then((resp) => {
                        const { value } = resp
                        if (value) {
                            const error = value.data.messages[0]
                            if (error.status == 'success') {
                                this.notificationTargetDeletedSuccessfully()
                                this.$router.back()
                            } else {
                                switch (error.params) {
                                    case 'usedInFormula':
                                        Swal({
                                            type: 'error',
                                            title: i18n.t('notification.somethingWentWrong'),
                                            text: i18n.t('notification.delete.usedInFormula'),
                                        })
                                        break
                                    default:
                                        this.notificationError()
                                        break
                                }
                            }
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                        this.notificationError()
                    })
            }
        },
        notificationTargetDeletedSuccessfully() {
            success(
                i18n.t('notification.deletedSuccessfully', {
                    item: i18n.t('targets.target'),
                })
            )
        },
        notificationError() {
            danger()
        },
    },
}
</script>

<style>
@media (max-width: 575px) {
    .text-small-sm-down {
        font-size: 12px !important;
        margin-bottom: 8px !important;
    }
}
</style>
